export const VIPAwardPointsStatusEnum = {
  Success: "success",
  Voided: "voided",
};
